// Function to get color based on climb rate
function getClimbColorHex(climb) {
  const roundedClimb = Math.round(climb * 2) / 2;

  if (roundedClimb === 0) {
    return "#00E3FF";
  } else if (roundedClimb > 0) {
    if (roundedClimb === 0.5) {
      return "#FFDB00";
    } else if (roundedClimb === 1.0) {
      return "#FFB700";
    } else if (roundedClimb === 1.5) {
      return "#FF9300";
    } else if (roundedClimb === 2.0) {
      return "#F37200";
    } else if (roundedClimb === 2.5 || roundedClimb === 3.0) {
      return "#FF4B00";
    } else if (roundedClimb === 3.5) {
      return "#F92B00";
    } else if (roundedClimb === 4.0) {
      return "#FF0400";
    } else if (roundedClimb >= 4.5) {
      return "#FF0044";
    } else {
      return "#FF0044";
    }
  } else {
    if (roundedClimb === -0.5) {
      return "#00E3FF";
    } else if (roundedClimb === -1.0 || roundedClimb === -1.5) {
      return "#00C7FF";
    } else if (roundedClimb === -2.0) {
      return "#0090FF";
    } else if (roundedClimb === -2.5) {
      return "#0074FF";
    } else if (roundedClimb === -3.0) {
      return "#0058FF";
    } else if (roundedClimb === -3.5) {
      return "#003CFF";
    } else if (roundedClimb === -4.0) {
      return "#0020FF";
    } else if (roundedClimb === -4.5) {
      return "#0004FF";
    } else if (roundedClimb === -5.0) {
      return "#1800FF";
    } else if (roundedClimb === -5.5) {
      return "#3403FB";
    } else if (roundedClimb === -6.0) {
      return "#4F00FF";
    } else if (roundedClimb === -6.5 || roundedClimb === -7.0) {
      return "#6B00FF";
    } else if (roundedClimb === -7.5) {
      return "#A105F7";
    } else if (roundedClimb === -8.0) {
      return "#DB00FF";
    } else if (roundedClimb === -8.5) {
      return "#BF00FF";
    } else if (roundedClimb === -9.0) {
      return "#F700FF";
    } else if (roundedClimb === -9.5) {
      return "#F700FF";
    } else if (roundedClimb <= -10.0) {
      return "#FF00B4";
    } else {
      return "#FF00B4";
    }
  }
}

function getClimbColorRgba(climb) {
  const colorHex = getClimbColorHex(climb);
  const colorRgba = [
    parseInt(colorHex.substr(1, 2), 16),
    parseInt(colorHex.substr(3, 2), 16),
    parseInt(colorHex.substr(5, 2), 16),
    255,
  ];
  return colorRgba;
}

export { getClimbColorRgba };
